<p *ngIf="dataService.curFilter().length > 0">
  <ion-chip *ngFor="let filter of dataService.curFilter(); index as pos">
    <ion-label>{{filter}}</ion-label>
    <ion-icon name="close-circle" 
              (click)="removeFilter(pos)"></ion-icon>
  </ion-chip>
</p>
<mat-form-field floatLabel="auto" style="width: 100%;">
    <mat-label>Todos los dispositivos</mat-label>
    <input type="text"
           aria-label="Number"
           matInput
           [formControl]="myControl"
           [matAutocomplete]="auto">
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
      <mat-option *ngFor="let option of filteredOptions | async" 
                  [value]="''"
                  (click)="addFilter(option)">
        {{ option }}
      </mat-option>
    </mat-autocomplete>
</mat-form-field>